module.exports = __webpack_public_path__ + "resources/img/img_dataquery_en.954a472504ff55f2b85ed6f3c9f6eb78.png";